import { NgModule } from '@angular/core';
import { NgClass, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';

import { AuthMenuComponent } from './components/auth-menu/auth-menu.component';
import { LoginCallbackComponent } from './components/login-callback/login-callback.component';
import { CardNotificationComponent } from './components/card-notification/card-notification.component';
import { LogoutCallbackComponent } from './components/logout-callback/logout-callback.component';


@NgModule({
    imports: [
        NgClass,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        RouterModule.forRoot([]),
        HttpClientModule,
        
        CollapseModule.forRoot(),
        BsDropdownModule.forRoot(),
    ],
    exports: [
        AuthMenuComponent,
        LoginCallbackComponent,
        LogoutCallbackComponent
    ],
    declarations: [
        AuthMenuComponent,
        CardNotificationComponent,
        LoginCallbackComponent,
        LogoutCallbackComponent
    ],
    providers: [
        BsDropdownConfig,
        // https://stackoverflow.com/a/56119617/2509064
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        JwtHelperService,
        CookieService
    ],
})
export class AuthMenuModule { }
